import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { utils, translate, ui } from 'parking-react-common'

import { topUps, payments, users, filters } from '../redux'

import List from '../components/List'
import Label from '../components/Label'
import UserDisplay from '../components/UserDisplay'
import TZDateTime from './TZDateTime'
import ListTotals from './ListTotals'

const stateIntents = {
    [topUps.STATES.pending]    : ui.INTENT.warning,
    [topUps.STATES.successful] : ui.INTENT.success,
    [topUps.STATES.failed]     : ui.INTENT.error
}

const TopUpsList = ({ dataSelector, dataURL, t }) => {
    const columns = [
        {
            key    : 'confirmed_amount',
            title  : t('Amount'),
            parse  : ({ rowData }) => parseFloat(rowData.confirmed_amount || rowData.requested_amount),
            render : ({ cellData, rowData }) => utils.formatAmountWithUnit(cellData, rowData.currency),
            total  : (data) => <ListTotals field="confirmed_amount" unitField="currency" data={ data } />
        },
        {
            key    : 'moment',
            title  : t('Moment'),
            render : ({ cellData }) => ( // eslint-disable-line react/prop-types
                <TZDateTime input={ cellData } />
            )
        },
        {
            key    : 'user',
            title  : t('User'),
            render : ({ cellData }) => ( // eslint-disable-line react/prop-types
                <UserDisplay user={ cellData } />
            )
        },
        {
            key    : 'state',
            title  : t('State'),
            render : ({ cellData }) => { // eslint-disable-line react/prop-types
                const intent = stateIntents[cellData]
                return <Label intent={ intent } text={ cellData } />
            }
        }
    ]

    const searchKeys = ['confirmed_amount', 'state', ...users.getSearchKeys()]
    const filterKeys = {
        moment: filters.TYPES.dateRange
    }

    return (
        <List
            title={ t('Top Ups') }
            columns={ columns }
            dataURL={ dataURL }
            dataSelector={ dataSelector }
            searchKeys={ searchKeys }
            filterKeys={ filterKeys }
            sortBy="moment"
            isDownloadable
        />
    )
}

TopUpsList.propTypes = {
    dataSelector : PropTypes.func,
    dataURL      : PropTypes.string
}

TopUpsList.defaultProps = {
    dataSelector : topUps.getAll,
    dataURL      : 'topUps'
}

function mapStateToProps(state, ownProps) {
    const dataSelector = (state) => {
        const topUps = ownProps.dataSelector(state)
        return utils.enhance(topUps, {
            user    : ({ user }) => users.getForID(user)(state),
            payment : ({ payment }) => payments.getForID(payment)(state)
        })
    }

    return {
        dataSelector
    }
}


export default translate()(connect(mapStateToProps)(TopUpsList))
